export const en = {
  billing: {
    title: 'Billing & Subscription',
    description: 'Manage your subscription and billing information',
    currentPlan: 'Current Plan',
    upgradePlan: 'Upgrade Your Plan',
    choosePlan: "Choose the plan that's right for you",
    features: 'Features',
    billingInfo: 'Billing Information',
    currentPeriod: 'Current Period',
    manageSubscription: 'Manage Subscription',
    selectPlan: 'Select {plan}',
    popular: 'Popular',
    savePercent: 'Save {percent}%',
    perMonth: '/month',
    perYear: '/year',
    billedAnnually: '(billed annually)',
    monthly: 'Monthly',
    annual: 'Annual',
    success: {
      title: 'Subscription Activated!',
      description: 'Your payment was successful and your subscription is now active.',
      message: 'You now have access to all premium features. Thank you for your purchase!',
      planActivated: 'has been activated',
      goToApp: 'Go to App',
      manageBilling: 'Manage Billing',
      continue: 'Continue to Billing',
    },
    cancel: {
      title: 'Payment Canceled',
      description: 'Your payment was canceled and no charges were made.',
      message: 'You can try again anytime. If you need help, please contact our support team.',
      tryAgain: 'Try Again',
      goToApp: 'Go to App',
    },
    status: {
      active: 'Active',
      canceled: 'Canceled',
      canceling: 'Canceling',
      pastDue: 'Past Due',
      grandfathered: 'Grandfathered',
    },
    grandfathered: {
      title: 'Lifetime Pro Access',
      message: 'You have grandfathered lifetime access to Pro features. Thank you for being an early supporter!',
    },
    planSuffix: 'Plan',
    currentPeriodLabel: 'Current Period:',
    subscriptionWillCancel: 'Subscription will cancel on',
    plans: {
      free: {
        name: 'Free',
        description: 'Get started with basic features',
        fullName: 'Free Plan',
        features: {
          basicGearManagement: 'Basic gear management',
          dataExport: 'Data export (JSON/Markdown)',
          byok: 'BYOK: Bring Your Own API Key (OpenRouter)',
          storage: '100 MB storage',
          itemsLimit: '2,000 items limit',
          containersLimit: '100 containers limit',
        },
      },
      pro: {
        name: 'Pro',
        description: 'Perfect for personal use',
        fullName: 'Pro Plan',
        features: {
          everythingInFree: 'Everything in Free',
          aiRecommendations: 'AI-powered gear recommendations',
          aiTokens: '~$1 worth of AI tokens/month',
          advancedFeatures: 'Advanced features',
          storage: '5 GB storage',
          itemsLimit: '10,000 items limit',
          containersLimit: '250 containers limit',
        },
      },
      pro_plus: {
        name: 'Pro Plus',
        description: 'Maximum limits for power users',
        fullName: 'Pro Plus Plan',
        features: {
          everythingInPro: 'Everything in Pro',
          priorityAi: 'Priority AI processing',
          aiTokens: '~$10 worth of AI tokens/month',
          premiumSupport: 'Premium support',
          storage: '50 GB storage',
          itemsLimit: '50,000 items limit',
          containersLimit: '500 containers limit',
        },
      },
    },
    upgradeBanner: {
      title: 'Unlock Premium Features',
      description: 'Upgrade to Pro for AI-powered recommendations, advanced features, and more storage.',
      button: 'View Plans',
      dismiss: 'Dismiss premium banner',
    },
    errors: {
      checkoutFailed: 'Failed to create checkout session. Please try again.',
      portalFailed: 'Failed to open billing portal. Please try again.',
    },
  },
}
